import { render, staticRenderFns } from "./TextSectionEditor.vue?vue&type=template&id=24912218"
import script from "./TextSectionEditor.vue?vue&type=script&lang=ts"
export * from "./TextSectionEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports